module.exports = __webpack_public_path__ + "202222:4f4eb5d45eb7a9e97a70/img/Luminary-homepage-3-L-1024x576.258b81c.jpg";